exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".block-select{width:88px}.block-select__wrapper{display:inline-block;vertical-align:bottom;height:40px;border-top:1px solid #cacaca;border-bottom:1px solid #cacaca;border-right:1px solid #cacaca}.block-select .Select-control{border:none;height:38px}.block-select .Select--single>.Select-control .Select-value,.block-select .Select-placeholder{line-height:45px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/_app/estimations/editor/tools/RichUtils/styles/BlockSelect.scss
// module id = 529
// module chunks = 1 2